import { render } from "./ReportGantt.vue?vue&type=template&id=488e9fc6&scoped=true"
import script from "./ReportGantt.vue?vue&type=script&lang=js"
export * from "./ReportGantt.vue?vue&type=script&lang=js"

import "./ReportGantt.vue?vue&type=style&index=0&id=488e9fc6&lang=less&scoped=true"

import exportComponent from "C:\\projects\\epd-cnmp-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488e9fc6"]])

export default __exports__